export const generateSchema = function (appConfig) {
  const minBudget = appConfig.get('BudgetRange').DailyRange.FloorValue;
  const maxBudget = appConfig.get('BudgetRange').DailyRange.CeilingValue;

  const minBid = appConfig.get('KeywordBidRange').FloorValue;
  const maxBid = appConfig.get('KeywordBidRange').CeilingValue;

  const schema = {
    name: 'recommendation details view form',
    type: 'object',
    properties: {
      budgetSuggested: {
        required: true,
        default: '', // required, otherwise it will not have first required check.
        type: 'number',
        minimum: minBudget,
        maximum: maxBudget,
      },
      suggestedBid: {
        required: true,
        default: '',
        type: 'number',
        minimum: minBid,
        maximum: maxBid,
      },
    },
  };

  return schema;
};
